import { ITags, render } from 'micromustache';
import { compiler } from 'markdown-to-jsx';

const tags: ITags = ['{', '}'];

export const content = (string: string = '', data?: object) =>
  compiler(render(string, data, { tags }), {
    wrapper: null,
  });
